import { APIProvider } from '@vis.gl/react-google-maps';
import type { ReactNode } from 'react';

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API;

  if (!apiKey) {
    // Still inside the provider, deliberately. Dropping it used to look like a graceful
    // degrade, but <Map> throws "can only be used inside an <ApiProvider>" and takes the
    // whole page down through the error boundary — so a missing key broke every page with a
    // map, not just the map. With the provider in place the map renders its own auth error
    // and the rest of the page keeps working.
    console.error("Google Maps API key is missing. Check your .env file.");
  }

  return (
    <APIProvider apiKey={(apiKey as string) ?? ""}>
      {children}
    </APIProvider>
  );
}
